const createWidgetFactory = require('components-framework/widget/create_widget_factory');

module.exports = createWidgetFactory({
    name: 'aircraftmap_manager',

    viewClass: require('./view'),

    methods: {
        onOpenAircraftMap(seatMap, aircraftOptions) {
            this.openAircraftMap(seatMap, aircraftOptions);
        },

        onTapRetainSelection() {
            this.onTapRetainSelection();
        },

        onTapRemoveSelection() {
            this.onTapRemoveSelection();
        },

        cancelAircraftMoveThrough() {
            this.cancelAircraftMoveThrough();
        },

        checkPassengerCollectionPopulated() {
            this.checkPassengerCollectionPopulated();
        },
        initSeatMapCheckinScroll() {
            this.autoScrollAircraftMap();
        },
        autoScrollFirstSection() {
            this.autoScrollAircraftMap();
        },
        updateShoppingCart() {
            this.updateShoppingCart();
        },
    },
});
